import { render, staticRenderFns } from "./BP.vue?vue&type=template&id=7d6fb117&scoped=true"
import script from "./BP.vue?vue&type=script&lang=js"
export * from "./BP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6fb117",
  null
  
)

export default component.exports